export const iaqColumnList = [
  { id: 0, value: "SelectAll", isChecked: false },
  { id: 2, value: "temprature", isChecked: false },
  { id: 3, value: "humidity", isChecked: false },
  { id: 4, value: "pmi_1", isChecked: false },
  { id: 5, value: "pmi_2_5", isChecked: false },
  { id: 6, value: "pmi10", isChecked: false },
  { id: 7, value: "co2", isChecked: false },
  { id: 8, value: "co", isChecked: false },
  { id: 9, value: "tvoc", isChecked: false },
  { id: 10, value: "ch2o", isChecked: false }
];